// src/components/Home.js
import React, { useEffect, useState } from "react";
import "./home.css";

/**
 * HERO SLIDER IMAGES
 * Mix of Sentosa Hoarding, NUH, and Singapore Badminton Association
 */
const heroImages = [
  // Sentosa Hoarding
  "/references/sentosa/hoarding_1.jpg",
  "/references/sentosa/hoarding_3.jpg",
  "/references/sentosa/hoarding_6.jpg",

  // National University Hospital
  "/references/national-university-hospital/nuh_1.jpg",
  "/references/national-university-hospital/nuh_3.jpg",
  "/references/national-university-hospital/nuh_5.jpg",

  // Singapore Badminton Association
  "/references/singapore-badminton-association/singapore-badminton-association_1.jpg",
  "/references/singapore-badminton-association/singapore-badminton-association_4.jpg",
  "/references/singapore-badminton-association/singapore-badminton-association_7.jpg",
];

export default function Home() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroImages.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="home">

      {/* ================= HERO ================= */}
      <section className="hero">

        {/* Background slider */}
        <div className="hero-slider">
          {heroImages.map((img, i) => (
            <div
              key={i}
              className={`slide ${i === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
        </div>

        {/* Dark overlay */}
        <div className="hero-overlay" />

        {/* Content */}
        <div className="hero-content">
          <span className="hero-tag">Business & Construction Solutions</span>

          <h1>
            We Build Reliable <br />
            <span>Renovation & Construction</span> Solutions
          </h1>

          <p>
            Shamshine Pte Ltd delivers professional renovation, construction,
            and engineering services across commercial, institutional,
            and infrastructure projects.
          </p>

          <div className="hero-actions">
            <a href="/services" className="btn-primary">
              View Services
            </a>
            <a href="/contact" className="btn-secondary">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="services-section">
        <h2>Our Services</h2>
        <p className="services-intro">
          Comprehensive renovation and construction services delivered
          with safety, quality, and reliability.
        </p>

        <div className="services-grid">
          <div className="service-card">
            <h3>Renovation Works</h3>
            <p>End-to-end residential and commercial renovation solutions.</p>
          </div>

          <div className="service-card">
         <h3>Electrical Services</h3>
            <p>Certified installation, upgrading, and maintenance works.</p>
          </div>

          <div className="service-card">
            <h3>Plumbing Works</h3>
            <p>Water supply, sanitary piping, drainage, and leak rectification.</p>
          </div>

          <div className="service-card">
            <h3>Painting Works</h3>
            <p>Interior and exterior painting with professional finishes.</p>
          </div>

          <div className="service-card">
            <h3>Hacking Works</h3>
            <p>Controlled wall and floor hacking with proper site protection.</p>
          </div>

          <div className="service-card">
            <h3>Demolition Works</h3>
            <p>Partial and full demolition with safe disposal and reinstatement.</p>
          </div>
        </div>
      </section>

    </div>
  );
}
